import React, { useEffect, useState } from 'react';
import './App.css';
import SiteNavigation from './components/SiteNavigation';
import LearnPage from './sections/LearnPage';
import { blogPosts } from './content/blogPosts';
import AppStoreButton from './components/AppStoreButton';
import AnywhereSection from './sections/AnywhereSection';
import FAQSection from './sections/FAQSection';
import Footer from './sections/Footer';
import HeroBanner from './sections/HeroBanner';
import HeroSection from './sections/HeroSection';
import ProgressSection from './sections/ProgressSection';
import QuickToolsSection from './sections/QuickToolsSection';
import TrainingPlanSection from './sections/TrainingPlanSection';

function App({ path = '/' }) {
  const isLearn = path === '/learn' || path.startsWith('/learn/');
  const post = blogPosts.find((entry) => path.replace(/\/$/, '') === `/learn/${entry.slug}`);
  const [showMobileDock, setShowMobileDock] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowMobileDock(window.scrollY > 80);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="site-shell">
      <SiteNavigation isLearn={isLearn} />
      {isLearn ? <LearnPage post={post} /> : (
        <>
          <HeroSection />
          <main>
            <HeroBanner />
            <TrainingPlanSection />
            <QuickToolsSection />
            <ProgressSection />
            <AnywhereSection />
            <FAQSection />
          </main>
        </>
      )}
      <Footer />
      {!isLearn && <div className={`mobile-download-dock${showMobileDock ? ' is-visible' : ''}`}>
        <AppStoreButton appleLogo text="Try It Now" />
      </div>}
    </div>
  );
}

export default App;
